import React from "react";
import { css } from "glamor";
import { Link } from "react-router-dom";
import { Tunnel } from "react-tunnels";
import { Query } from "react-apollo";

import { Alert, Spin } from "antd";

import DetailView from "../../container/DetailView";
import { removeTypenames } from "../../util";
import { withApolloState } from "../../util/apollo";
import { EntityProfile } from "./EntityProfile";
import { ENTITY_DETAILS_QUERY } from "./queries";

const styles = {
    loading: {
        animate: true,
        spinner: true,
        text: "Loading...",
        background: "white",
        color: "#545456",
    },
    alert: css({
        marginBottom: 36,
    }),
};

class EntityDetailPage extends React.Component {
    state = { canEdit: true, showSpinner: false };

    toggleSpinner = () =>
        this.setState({ showSpinner: !this.state.showSpinner });

    render() {
        const ulid = this.props.match.params.ulid;
        const tab = this.props.match.params.tab;
        const entityId = btoa(`Entity:${ulid}`);

        // We need to switch the fetchPolicy from cache-and-network to cache-first when navigating between
        // tabs to prevent full page re-renders. Currently our url routing causes the component to completely
        // unmount.
        const fetchPolicy = tab ? "cache-first" : "cache-and-network";

        if (this.state.showSpinner) {
            return <Spin spinning tip="Loading..." />;
        }

        return (
            <Query
                query={ENTITY_DETAILS_QUERY}
                fetchPolicy={fetchPolicy}
                variables={{
                    id: entityId,
                    ulid,
                }}
            >
                {withApolloState(
                    ({ data, refetch }) => {
                        const {
                            EntitySchema,
                            RelationSchema,
                            SentryPolicySchema,
                            lobTermination,
                        } = data;
                        const entity = removeTypenames(data.entity);
                        const mergedLink = `/entities/${entity.rootMergedEntity.key.ulid}`;
                        const mergedName = entity.hasBeenMerged && (
                            <>
                                This entity has been merged into&nbsp;
                                <Link to={mergedLink}>
                                    {entity.rootMergedEntity.name}
                                </Link>
                            </>
                        );

                        entity.linesOfBusiness = [
                            ...entity.linesOfBusiness,
                            ...lobTermination,
                        ];

                        return (
                            <>
                                <Tunnel id="bluebar-left-content">
                                    {entity ? (
                                        <EntityProfile
                                            entity={entity}
                                            schema={EntitySchema}
                                            refetchEntity={refetch}
                                            sentryPolicySchema={
                                                SentryPolicySchema
                                            }
                                        />
                                    ) : null}
                                </Tunnel>

                                {entity.isArchived && (
                                    <Alert
                                        className={`${styles.alert}`}
                                        message={
                                            mergedName ||
                                            "This entity has been archived"
                                        }
                                        type="warning"
                                        showIcon
                                    />
                                )}

                                {data.entity && (
                                    <DetailView
                                        entity={entity}
                                        entitySchema={EntitySchema}
                                        relationSchema={RelationSchema}
                                        sentryPolicySchema={SentryPolicySchema}
                                        processes={entity.processes}
                                        canEdit={
                                            this.state.canEdit &&
                                            !entity.isArchived
                                        }
                                        history={this.props.history}
                                        toggleSpinner={this.toggleSpinner}
                                    />
                                )}
                            </>
                        );
                    },
                    () => (
                        <Spin spinning tip="Loading..." />
                    )
                )}
            </Query>
        );
    }
}

export default EntityDetailPage;
